enum Key {
  Backspace = 'Backspace',
  Enter = 'Enter'
}

export default Key;
